import styled from "styled-components";
import { WithThemeType } from "@/types/WithThemeType";
import { deviceSizeQuery } from "@motain/web-shared-hub/constants";

export const BackgroundWrapper = styled.div<WithThemeType>`
  margin-top: 5rem;
  background-color: #000;
  padding: 1.625rem 0;
  border: ${(p) => `1px solid ${p.theme.colors.border}`};
  border-radius: 1rem;

  @media all and ${deviceSizeQuery.tabletPortrait} {
    padding: 5.125rem 0;
  }
`;
